import { PageSize } from '@/constant';
import {
	GetExtensionStayListParams,
	IExtensionStay,
	TPayloadUpdateSuccess,
} from '@/services';
import { mergeItemUpdated, mergeListItemUpdated } from '@/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { formatExtensionStayList, RootState } from '..';
import {
	IApplicantByFranchiseExtensionStayDetailStore,
	IApplicantForExtensionStayDetailStore,
	IApplicantListByIdsDetailStore,
	ICreateApplicantForExtensionStayRequest,
	ICreateWorkerExtensionStayRequest,
	IExtensionStayDetailStore,
	IPayloadDeleteApplicantExtensionStayRequest,
	IPayloadDeleteExtensionStayRequest,
	IPayloadDeleteWorkerExtensionStayRequest,
	IPayloadGetApplicantByFranchiseExtensionStayListRequest,
	IPayloadGetApplicantByFranchiseExtensionStayListSuccess,
	IPayloadGetApplicantForExtensionStayListRequest,
	IPayloadgetApplicantForExtensionStayListSuccess,
	IPayloadGetApplicantListByIdsRequest,
	IPayloadGetApplicantListByIdsSuccess,
	IPayloadGetWorkerExtensionStayDetailRequest,
	IPayloadGetWorkerExtensionStayDetailSuccess,
	IPayloadGetWorkerExtensionStayExcelListRequest,
	IPayloadGetWorkerExtensionStayListRequest,
	IPayloadGetWorkerExtensionStayListSuccess,
	IUpdateFranchiseWorkerExtensionStayRequest,
	IWorkerExtensionStayDetailStore,
} from './worker-extension-stay.type';

const InitParams: GetExtensionStayListParams = {
	page: 1,
	pageSize: PageSize.S,
	searchTypes: [],
};
const initialState = {
	fetching: false,
	excelListFetching: false,
	workerExtensionStayList: [] as IExtensionStayDetailStore[],
	page: 1,
	total: 0,
	workerExtensionStayDetail: {} as IWorkerExtensionStayDetailStore,
	workerApplicantByFranchiseList:
		[] as IApplicantByFranchiseExtensionStayDetailStore[],
	workerApplicantListByIds: [] as IApplicantListByIdsDetailStore[],
	applicantForExtensionStayList: [] as IApplicantForExtensionStayDetailStore[],
	params: InitParams,
	totalApplicantList: 0,
};

const workerExtensionStaySlice = createSlice({
	initialState,
	name: 'workerExtensionStay',
	reducers: {
		/**---- GET WORKER_EXTENSION_STAY LIST START ---- */
		getWorkerExtensionStayListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerExtensionStayListRequest>
		) => {
			state.fetching = true;
			state.params = action.payload;
		},
		getWorkerExtensionStayListSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerExtensionStayListSuccess>
		) => {
			const { content, page, total } = action.payload;
			state.fetching = false;
			state.workerExtensionStayList = content;
			state.page = page;
			state.total = total;
		},
		getWorkerExtensionStayListFailure: (state) => {
			state.fetching = false;
			state.total = 0;
			state.workerExtensionStayList = [];
		},

		getWorkerExtensionStayExcelListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerExtensionStayExcelListRequest>
		) => {
			state.excelListFetching = true;
		},
		getWorkerExtensionStayExcelListSuccess: (state) => {
			state.excelListFetching = false;
		},
		getWorkerExtensionStayExcelListFailure: (state) => {
			state.excelListFetching = false;
		},
		/**---- GET WORKER_EXTENSION_STAY LIST END ---- */

		/**---- GET WORKER_EXTENSION_STAY DETAIL START ---- */
		getWorkerExtensionStayDetailRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerExtensionStayDetailRequest>
		) => {
			state.fetching = true;
		},
		getWorkerExtensionStayDetailSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerExtensionStayDetailSuccess>
		) => {
			const { workerExtensionStayDetail } = action.payload;
			state.fetching = false;
			state.workerExtensionStayDetail = workerExtensionStayDetail;
		},
		getWorkerExtensionStayDetailFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET WORKER_EXTENSION_STAY DETAIL END ---- */

		/**---- CREATE WORKER_EXTENSION_STAY START ---- */
		createWorkerExtensionStayRequest: (
			state,
			action: PayloadAction<ICreateWorkerExtensionStayRequest>
		) => {
			state.fetching = true;
		},
		createWorkerExtensionStaySuccess: (state) => {
			state.fetching = false;
		},
		createWorkerExtensionStayFailure: (state) => {
			state.fetching = false;
		},
		/**---- CREATE WORKER_EXTENSION_STAY END ---- */

		/**---- GET WORKER_EXTENSION_STAY LIST START ---- */
		getApplicantByFranchiseExtensionStayListRequest: (
			state,
			action: PayloadAction<IPayloadGetApplicantByFranchiseExtensionStayListRequest>
		) => {
			state.fetching = true;
		},
		getApplicantByFranchiseExtensionStayListSuccess: (
			state,
			action: PayloadAction<IPayloadGetApplicantByFranchiseExtensionStayListSuccess>
		) => {
			const { content } = action.payload;
			state.fetching = false;
			state.workerApplicantByFranchiseList = content;
		},
		getApplicantByFranchiseExtensionStayListFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET WORKER_EXTENSION_STAY LIST END ---- */

		/**---- GET APPLICANT LIST BY IDS START ---- */
		getApplicantListByIdsRequest: (
			state,
			action: PayloadAction<IPayloadGetApplicantListByIdsRequest>
		) => {
			state.fetching = true;
		},
		getApplicantListByIdsSuccess: (
			state,
			action: PayloadAction<IPayloadGetApplicantListByIdsSuccess>
		) => {
			const { content } = action.payload;
			state.fetching = false;
			state.workerApplicantListByIds = content;
		},
		getApplicantListByIdsFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET APPLICANT LIST BY IDS END ---- */

		/**---- DELETE WORKER_EXTENSION_STAY START ---- s*/
		deleteWorkerExtensionStayRequest: (
			state,
			action: PayloadAction<IPayloadDeleteWorkerExtensionStayRequest>
		) => {
			state.fetching = true;
		},
		deleteWorkerExtensionStaySuccess: (state) => {
			state.fetching = false;
		},
		deleteWorkerExtensionStayFailure: (state) => {
			state.fetching = false;
		},
		/**---- DELETE WORKER_EXTENSION_STAY END ---- */

		/**---- UPDATE FRANCHIE WORKER_EXTENSION_STAY START ---- */
		updateFranchiseWorkerExtensionStayRequest: (
			state,
			action: PayloadAction<IUpdateFranchiseWorkerExtensionStayRequest>
		) => {
			state.fetching = true;
		},
		updateFranchiseWorkerExtensionStaySuccess: (state) => {
			state.fetching = false;
		},
		updateFranchiseWorkerExtensionStayFailure: (state) => {
			state.fetching = false;
		},
		/**---- UPDATE FRANCHIE WORKER_EXTENSION_STAY END ---- */

		/**---- GET APPLICANT WORKER_EXTENSION_STAY LIST START ---- */
		getApplicantForExtensionStayListRequest: (
			state,
			action: PayloadAction<IPayloadGetApplicantForExtensionStayListRequest>
		) => {
			state.fetching = true;
		},
		getApplicantForExtensionStayListSuccess: (
			state,
			action: PayloadAction<IPayloadgetApplicantForExtensionStayListSuccess>
		) => {
			const { content } = action.payload;
			state.fetching = false;
			state.applicantForExtensionStayList = content;
		},
		getApplicantForExtensionStayListFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET APPLICANT WORKER_EXTENSION_STAY LIST END ---- */

		/**---- DELETE APPLICANT WORKER_EXTENSION_STAY START ---- */
		deleteApplicantExtensionStayRequest: (
			state,
			action: PayloadAction<IPayloadDeleteApplicantExtensionStayRequest>
		) => {
			state.fetching = true;
		},
		deleteApplicantExtensionStaySuccess: (state) => {
			state.fetching = false;
		},
		deleteApplicantExtensionStayFailure: (state) => {
			state.fetching = false;
		},
		/**---- DELETE APPLICANT WORKER_EXTENSION_STAY END ---- */

		/**---- CREATE APPLICANT WORKER_EXTENSION_STAY START ---- */
		createApplicantForExtensionStayRequest: (
			state,
			action: PayloadAction<ICreateApplicantForExtensionStayRequest>
		) => {
			state.fetching = true;
		},
		createApplicantForExtensionStaySuccess: (state) => {
			state.fetching = false;
		},
		createApplicantForExtensionStayFailure: (state) => {
			state.fetching = false;
		},
		/**---- CREATE APPLICANT WORKER_EXTENSION_STAY END ---- */

		/**---- UPDATE WORKER_EXTENSION_STAY START ---- */
		updateWorkerExtensionStaySuccess: (
			state,
			action: PayloadAction<TPayloadUpdateSuccess<IExtensionStay>>
		) => {
			const { data } = action.payload;
			const content = [...state.workerExtensionStayList];

			state.workerExtensionStayList = formatExtensionStayList(
				mergeListItemUpdated(content, data) as []
			);
		},
		updateWorkerExtensionStayDetailSuccess: (
			state,
			action: PayloadAction<
				TPayloadUpdateSuccess<IWorkerExtensionStayDetailStore>
			>
		) => {
			const { data } = action.payload;
			const workerExtensionStayDetail = { ...state.workerExtensionStayDetail };
			state.workerExtensionStayDetail = mergeItemUpdated(
				workerExtensionStayDetail,
				data
			);
		},
		/**---- UPDATE WORKER_EXTENSION_STAY END ---- */

		/**---- DELETE EXTENSION STAY START ---- s*/
		deleteExtensionStayRequest: (
			state,
			action: PayloadAction<IPayloadDeleteExtensionStayRequest>
		) => {
			state.fetching = true;
		},
		deleteExtensionStaySuccess: (state) => {
			state.fetching = false;
		},
		deleteExtensionStayFailure: (state) => {
			state.fetching = false;
		},
		/**---- DELETE EXTENSION STAY END ---- */
	},
});

export const WorkerExtensionStaySelectors = {
	selectFetching: (state: RootState) => state.workerExtensionStay.fetching,
	selectPage: (state: RootState) => state.workerExtensionStay.page,
	selectTotal: (state: RootState) => state.workerExtensionStay.total,
	selectList: (state: RootState) =>
		state.workerExtensionStay.workerExtensionStayList,
	selectDetail: (state: RootState) =>
		state.workerExtensionStay.workerExtensionStayDetail,
	selectApplicantList: (state: RootState) =>
		state.workerExtensionStay.applicantForExtensionStayList,
	selectApplicantByFranchiseList: (state: RootState) =>
		state.workerExtensionStay.workerApplicantByFranchiseList,
	selectApplicantListByIds: (state: RootState) =>
		state.workerExtensionStay.workerApplicantListByIds,
	selectParams: (state: RootState) => state.workerExtensionStay.params,
	selectApplicantTotal: (state: RootState) =>
		state.workerExtensionStay.totalApplicantList,
};

export const WorkerExtensionStayActions = workerExtensionStaySlice.actions;
export const WorkerExtensionStayReducer = workerExtensionStaySlice.reducer;
